import React from 'react';
import ProfileImage from './ProfileImage';

const  PhotoContainer = ({image, username}) =>{
    return(
            <ProfileImage image={image} username={username}/>
    )
};

export default PhotoContainer;